import { render, staticRenderFns } from "./ModalApprovedDenomination.vue?vue&type=template&id=0f1d1230&"
import script from "./ModalApprovedDenomination.vue?vue&type=script&lang=ts&"
export * from "./ModalApprovedDenomination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports